<div class="mb-4 rounded-2xl bg-white p-6 filters-shadow">
  <div class="mb-5 grid grid-cols-4 gap-6">
    <app-pharmacy-auto-complete
      class="col-span-2"
      [label]="pharmacyLabel"
      [placeholder]="pharmacyPlaceholder"
      [noResultsText]="noPharmacyResults"
      [clear]="pharmacyClear()"
      (itemSelected)="onPharmacySelected($event)"></app-pharmacy-auto-complete>

    <div>
      <app-filter-item-search
        [label]="invoiceIdFilter"
        [placeholder]="invoiceIdPlaceholder"
        [isInvalid]="!!invoiceIdError()"
        [(searchTerm)]="invoiceSearch" />

      @if (invoiceIdError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ invoiceIdError() }}
        </p>
      }
    </div>

    <div>
      <app-filter-item-search
        [label]="orderIdFilter"
        [placeholder]="orderIdPlaceholder"
        [isInvalid]="!!orderIdError()"
        [(searchTerm)]="orderSearch" />

      @if (orderIdError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ orderIdError() }}
        </p>
      }
    </div>
  </div>
  <div class="mb-6 grid grid-cols-4 gap-6">
    <app-filter-multi-select
      [label]="statusFilter()"
      [items]="statusOptions()"
      [placeholder]="allStatuses()"
      [(selectedIds)]="selectedStatuses"
      [showDropdown]="showStatusDropdown()"
      (toggleDropdown)="toggleStatusDropdown()"
      (selectionChange)="onStatusChange($event)" />

    <div>
      <app-filter-date-component
        [label]="invoiceDateFrom"
        [value]="invoiceFrom()"
        (valueChange)="onFromDateChange($event)" />

      @if (fromDateError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ fromDateError() }}
        </p>
      }
    </div>

    <div>
      <app-filter-date-component [label]="invoiceDateTo" [value]="invoiceTo()" (valueChange)="onToDateChange($event)" />

      @if (toDateError()) {
        <p class="mt-1 text-xs text-red-500">
          {{ toDateError() }}
        </p>
      }
    </div>
  </div>
  <hr class="mb-5 border-gray-200" />

  <div class="flex items-center justify-between">
    <app-filter-sorting-component
      [(orderBy)]="filters().orderBy!"
      [orderDir]="filters().orderDir!"
      [sortOptions]="sortOptions()"
      (toggleOrder)="onToggleSortOrder()" />

    <div class="flex gap-3">
      <app-submit-button type="secondary" (click)="onResetFilters()">
        <span i18n="@@invoiceListReset">Clear</span>
      </app-submit-button>

      <app-submit-button type="primary" (click)="onApplyFilters()">
        <span i18n="@@invoiceListApply">Apply</span>
      </app-submit-button>
    </div>
  </div>
</div>
